import { Component } from '@angular/core';

import { NavParams, PopoverController } from '@ionic/angular';
import { Router } from '@angular/router';
import { NavUrls } from '../../../enums/nav-urls';

import { AlertService, AlertDialogButtonClick } from '../../../services/alert.service';

import { TranslateService } from '@ngx-translate/core';
import { FieldService } from 'src/app/services/field.service';
import { FieldV2Dto } from 'src/app/api/exa';

@Component({
  selector: '',
  templateUrl: './field-context-menu.component.html',
  styleUrls: ['../popover.component.scss'],
})
export class FieldContextMenuComponent {
  field_id: number;
  hasGrantToWriteField: boolean;
  fieldDTO: FieldV2Dto;

  constructor(
    private navParams: NavParams,
    private router: Router,
    private popoverController: PopoverController,
    private alertService: AlertService,
    private fieldService: FieldService,
    private translate: TranslateService
  ) {
    this.field_id = this.navParams.data.field_id;
    this.fieldDTO = this.navParams.data.fieldDTO;
    this.hasGrantToWriteField = this.navParams.data.hasFieldWriteGrant;
  }

  onClickEditGeometry() {
    let editFieldGeometryUrl = NavUrls.FIELDS + '/' + NavUrls.ADDEDITFIELDGEOMETRY + '/' + this.field_id;
    this.router.navigateByUrl(editFieldGeometryUrl);
    this.DismissClick();
  }

  onClickEditInformation() {
    let editFieldUrl = NavUrls.FIELDS + '/' + NavUrls.ADDEDITFIELDINFORMATION + '/' + this.field_id;
    this.router.navigateByUrl(editFieldUrl);
    this.DismissClick();
  }

  onClickActivate() {
    this.fieldDTO.active = true;
    this.fieldService.updateField(this.fieldDTO).then(
      (ret) => {
        console.log(' return: ', ret);
        this.DismissClick();
      },
      (err) => {
        console.log(' return: ', err);
      }
    );
  }

  onClickDeactivate() {
    this.fieldDTO.active = false;
    this.fieldService.updateField(this.fieldDTO).then(
      (ret) => {
        console.log(' return: ', ret);
        this.DismissClick();
      },
      (err) => {
        console.log(' return: ', err);
      }
    );
  }

  onClickDelete() {
    this.onClickDeleteField(this.field_id);
  }

  onClickDeleteField(fieldId: number) {
    // console.log(" POPOVER presenting. Löschung von Feld ", fieldId, "bestätigen: ");
    this.alertService
      .presentConfirmAlert(this.translate.instant('WARNING'), this.translate.instant('FIELD.DELETE.QUESTION'))
      .then((buttonClick) => {
        if (buttonClick == AlertDialogButtonClick.OK) {
          // console.log(" User hat Löschung bestätigt");
          this.fieldService.deleteField(fieldId).finally(() => {
            // egal was passiert das popover schliesst sich
            // Suchfilter zuruecksetzen in der machines.ts
            this.DismissClick();
          });
        }
      });
  }

  async DismissClick() {
    // dismiss the popover
    await this.popoverController.dismiss({ data: 'Hi' });
  }
}
